<template lang="html">
  <HeaderNavContent>
    <AppLogo />
    <NavHamburger />
  </HeaderNavContent>
</template>

<script>
import { mapGetters } from 'vuex';
import AppLogo from '@/components/AppLogo';
import HeaderNavContent from '@/components/HeaderNavContent';
import NavHamburger from '@/components/NavHamburger';

export default {
  name: 'HeaderNavDefault',

  components: {
    AppLogo,
    HeaderNavContent,
    NavHamburger,
  },
};
</script>

<style scoped lang="scss">
.app-logo {
  margin-right: map-get($app, 'spacing');
}
</style>
